{
    "group": {
        "api_key": "Api keys",
        "capability": "Permisos",
        "cms": "Edición web",
        "company": "Empresas",
        "company_abono": "Datos empresa Abonoteatro",
        "discount": "Descuentos",
        "discount_code": "Códigos descuento",
        "enclosure": "Recintos",
        "enclosure_all": "Recintos de todas las empresas",
        "enclosure_type": "Tipos de recinto",
        "event": "Eventos",
        "event_all": "Eventos de cualquier compañía",
        "event_assessment": "Evento - Valoraciones",
        "event_category": "Eventos - Categorías",
        "event_change_status": "Eventos - Estados",
        "event_change_status_to": "Eventos - Estados",
        "event_prices": "Eventos - Precios de abonados y acompañantes",
        "event_type": "Eventos - Tipos",
        "incidence": "Incidencias",
        "market": "Mercados",
        "notification": "Notificaciones",
        "operation": "Operaciones",
        "person": "Persona",
        "province": "Provincias",
        "report": "Informes",
        "report_action": "Acciones de informe",
        "role": "Roles",
        "role_market": "Roles de mercado",
        "subscriber": "Abonados",
        "subscription": "Abonos",
        "subscription_type": "Tipos de abono",
        "tax": "Impuestos",
        "template": "Plantillas generales",
        "township": "Localidades",
        "user": "Usuarios",
        "user_assign_to": "Asignar a",
        "user_can_be_incidences": "Agente de incidencias"
    }
}
